import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { LnLogoSvgIconComponent } from '../svg-icons/ln-logo-svg-icon/ln-logo-svg-icon.component';
import { LnPortalLogoSvgIconComponent } from '../svg-icons/ln-portal-logo-svg-icon/ln-portal-logo-svg-icon.component';
import { LnPropertiesLogoSvgIconComponent } from '../svg-icons/ln-properties-logo-svg-icon/ln-properties-logo-svg-icon.component';
import { NgClass } from '@angular/common';
import { MenuActions } from '../../states/menu_actions';
import { LnWhatsappSvgIconComponent } from '@components/svg-icons/ln-whatsapp-svg-icon/ln-whatsapp-svg-icon.component';
import { LnInstagramSvgIconComponent } from '@components/svg-icons/ln-instagram-svg-icon/ln-instagram-svg-icon.component';
import { environment } from '../../../../environments/environment';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ClipBoardService } from '@core/services/clipBoard/clip-board.service';

@Component({
  selector: 'ln-footer',
  imports: [
    LnLogoSvgIconComponent,
    LnPortalLogoSvgIconComponent,
    LnPropertiesLogoSvgIconComponent,
    NgClass,
    LnWhatsappSvgIconComponent,
    LnInstagramSvgIconComponent,
    TranslocoPipe,
    TranslocoDirective,
  ],
  templateUrl: './ln-footer.component.html',
  styleUrl: './ln-footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnFooterComponent {
  menuAction = inject(MenuActions);
  seizaWordMouseHover = signal(false);
  private readonly INSTAGRAM_URL: string = environment.LN_INSTAGRAM_URL;
  private readonly WHATSAPP_URL: string = environment.LN_WHATSAPP_URL;
  private clipboard = inject(ClipBoardService);

  navigateToSeizaWebPage() {
    this.menuAction.navigateToSeizaWebPage();
  }

  navigateToLunaNuevaPortalWebPage() {
    this.menuAction.navigateToLunaNuevaPortalWebPage();
  }

  navigateToLunaNuevaPropertiesWebPage() {
    this.menuAction.navigateToLunaNuevaPropertiesWebPage();
  }

  navigateToLunaNuevaBlog() {
    this.menuAction.navigateToBlog();
  }

  onHover() {
    this.seizaWordMouseHover.set(true);
  }

  onLeave() {
    this.seizaWordMouseHover.set(false);
  }

  navigateToWhatsapp(message: string) {
    const encodedMessage = '?text=' + encodeURIComponent(message);
    this.menuAction.navigateToURL(this.WHATSAPP_URL + encodedMessage);
  }

  navigateToInstagram(message: string) {
    this.clipboard.copy(message)?.then(() => this.menuAction.navigateToURL(this.INSTAGRAM_URL));
  }
  navigateToContactPage() {
    this.menuAction.navigateToContactPage();
  }

  navigateToAboutUsPage(): void {
    this.menuAction.navigateToAboutUsPage();
  }

  navigateToServicesPage(): void {
    this.menuAction.navigateToServices();
  }
}
